import { ThemeProvider } from '@material-ui/core';
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import { Component } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import ConfirmModal from './../utils/ConfirmModal';
import { hasPermission } from './../utils/usePermission';
import { DateTimeFormat } from './DateFormat/DateTimeFormat';
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";

export default class LabourList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labours: [],
      loading: false,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      showConfirm: false,
      deleteId: null,
      color: "",
    };
  }

  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };
  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  componentDidMount() {
    this.fetchLabours();
  }

  fetchLabours = () => {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    axios
      .get("/labours", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        this.setState({ labours: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching labours",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  handleDelete = () => {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    axios
      .delete(`/labours/${this.state.deleteId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        this.setState({
          showToast: true,
          showConfirm: false,
          toastMessage: "Labour deleted successfully",
          toastVariant: "success",
          color: 'green',
          deleteId: null,
          loading: false
        });
        this.fetchLabours();
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          toastMessage: error.response?.data?.message || "Error deleting labour",
          toastVariant: "danger",
          showConfirm: false,
          color: 'red',
          loading: false,
          deleteId: null,
        });
      });
  };
  handleMoveAdd = () => {
    this.props.history.push('/labour-add')
  }

  handleEdit = (rowData) => {
    console.log("rowData", rowData);
    const { labourid } = rowData;
    this.props.history.push(`/labour-add/${labourid}`, { data: rowData });
  };

  render() {
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          loading={this.state.loading}
          message="Are you sure you want to delete this Labour?"
        />
        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            <div className='d-flex search-btn-gap'>
              {
                hasPermission('M17S3B1') && (
                  <div className='add-role'>
                    <Button onClick={this.handleMoveAdd} variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button"> <i className="fa fa-plus-circle"></i> Add Labour</Button>
                  </div>
                )
              }
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>Labour List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      title="Labour List"
                      columns={[
                        { title: "ID", field: "labourid", editable: "never" },
                        { title: "Name", field: "name" },
                        { title: "HSN Code", field: "hsnCode" },
                        { title: "UOM", field: "uomData.name" },
                        { title: "Description", field: "description" },
                        {
                          title: "Created Date", field: "createdAt",
                          render: (text) => DateTimeFormat(text.createdAt),
                        },
                        {
                          title: 'Action',
                          render: rowData => (
                            <>
                              {hasPermission('M17S3B3') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Edit Labour</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info"
                                    onClick={() => this.handleEdit(rowData)}
                                  >
                                    <i class="fa fa-edit"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {hasPermission('M17S3B2') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Delete Labour</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-danger" className="mr-2 delete-btn"
                                    // onClick={() => this.handleDelete(rowData?.labourid)}
                                    onClick={() => this.setState({ showConfirm: true, deleteId: rowData.labourid })}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                            </>
                          )
                        }
                      ]}
                      data={this.state.labours}
                      // actions={[
                      //   {
                      //     icon: "add",
                      //     tooltip: "Add Labour",
                      //     isFreeAction: true,
                      //     onClick: () => this.props.history.push("/labour-add"),
                      //   },
                      //   {
                      //     icon: "delete",
                      //     tooltip: "Delete Labour",
                      //     onClick: (event, rowData) => this.handleDelete(rowData.labourid),
                      //   },
                      // ]}
                      options={{
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100],
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        actionsColumnIndex: -1,
                        search: true,
                        paging: true,
                      }}
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
        </CommonLoader>
      </>
    );
  }
}
